module.exports = __webpack_public_path__ + "d5310be8da44406a33251c282f5883be.MP3";